import React, { FunctionComponent as FC, useState, useEffect } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'; // To call Action Creators
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../../../state';
import { State } from '../../../../../state/reducers';

import { Button, Row, Col, Form, Input, Checkbox, Layout, Typography, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { jwtDecode } from 'jwt-decode';

import logo from '../../../../../assets/logo.png';
import logo_text from '../../../../../assets/logo-text.png';
import nsf_icon from '../../../../../assets/nsf.png';
import './index.scss';

const { Header, Content, Footer } = Layout;
const { Title, Text } = Typography;

// Function to check the token validity
export const checkToken = () => {
  const remem = localStorage.getItem("rememberMe");
  const storedLocalToken = localStorage.getItem("token");
  if (remem==="true" && storedLocalToken){
    sessionStorage.setItem("token", storedLocalToken)
  }
  const storedToken = sessionStorage.getItem("token");
  if(!storedToken) {
    return false;
  }
  try {
    const decoded = jwtDecode(storedToken);
    const currentTime = Date.now() / 1000;  // Convert milliseconds to seconds
    // return true
    if (decoded.exp === undefined) {
      return false;
    }
    return decoded.exp > currentTime;
  } catch (e) {
    return false;  // if token is invalid or expired
  }
};

type LoginFields = {
  username: string;
  password: string;
  remember: boolean;
};

interface LoginProps{

}


// const Login = () => {
const Login: FC<LoginProps> = (props) => {
  const {
  } = props

  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {
    performLogin,
  } = bindActionCreators(actionCreators, dispatch)

  const tokenStatus: string = useSelector((state: State) => state.uiReducer?.authState.token) as string;
  const authStatus: boolean = useSelector((state: State) => state.uiReducer?.authState.isAuthenticated) as boolean;
  const [rememberMe, setRememberMe] = useState<boolean>(false);

  useEffect(() => {
    if (authStatus && tokenStatus) {
      navigate('/');
      message.success('Login Successful!');
    }
  }, [authStatus, tokenStatus]);

  useEffect(() => {
    // const remembered = localStorage.getItem("rememberMe") === "true";
    // setRememberMe(remembered);
  }, []);

  // Function to handle form submission
  const onFinish = (values: LoginFields) => {
    performLogin(values)
  };

  // Function to handle submission failure
  const onFinishFailed = (errorInfo: any) => {
    console.log('Login failed:', errorInfo);
    message.error('Submission failed, please check your input.');
  };

  // const onFinish = (values: any) => {
  //   console.log("Login form values:", values);
  //   if ((values.username == "admin") && (values.password == "admin")){
  //     console.log("correct")
  //     navigate("/");
  //   } else {
  //     message.error("Incorrect Username or Password.")
  //   }
  // };

  // const onFinishFailed = (errorInfo: any) => {
  //   console.log("Login failed:", errorInfo);
  // };

  const handleRememberMeChange = (e: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
    // setRememberMe(e.target.checked);
    // localStorage.setItem("rememberMe", e.target.checked.toString());
  };

  return (
    <Layout className="login-layout">
      <Header style={{ backgroundColor: 'transparent', boxShadow: "none" }}>
      <Row justify="space-between" style={{width: '100%'}}>
        <Col xs={8} sm={8} md={8} lg={8}>
        <div className='header-left-div'>
              <div className='logo'>
              </div>
            </div>
          </Col>
        </Row>
      </Header>
      <Content className="login-content">
        <div className="login-wrapper">
          <div className="branding-section">
            <div className="branding-logo-div">
              <img src={logo_text} alt="logo" className="branding-logo"/>
            </div>
            <div className="branding-container">
              {/* <img src={logo_text} alt="logo" className="branding-logo"/> */}
              <div className="branding-text">
                FundingTheFrontier
              </div>
              <div className="branding-tagline">Visualizing the Broad Impact of Science and Science Funding</div>
              <div className="mobile-version-notice">Please use desktop version for best experience.</div>
            </div>
            <div className='branding-copyright'>
              <div className="content-item acknowledgement">
                <span className="acknowledgement-text">
                  This material is based upon work supported by the National Science Foundation under Grant No. 2404035. Any opinions, findings, and conclusions or recommendations expressed in this material are those of the author(s) and do not necessarily reflect the views of the National Science Foundation.
                </span>
                <div className="nsf-icon">
                  <img src={nsf_icon} alt="nsf" />
                </div>
              </div>
              <div className="content-item review-version">Review version 1.0.0 <a href="/tour_references/v3-20250909/0915-compressed.mp4" target="_blank">Demo Video</a></div>
                {/* Copyright © 2024-2025 CSSI */}
            </div>
          </div>
          <div className="content-wrapper">
            <div className="login-form">
              {/* <div className="login-text">Log in</div> */}
              <Form
                name="login"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                initialValues={{ remember: false }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="on"
              >
                <Form.Item
                  className="username-box"
                  name="username"
                >
                  <Input
                  prefix={<UserOutlined
                  className="site-form-item-icon" />}
                  placeholder="User Name"
                  style={{ borderRadius: '16px', border: 'none', boxShadow: 'none', color: '#1a1a1a'}}/>
                </Form.Item>
                <Form.Item
                  className="password-box"
                  name="password"
                >
                  <Input
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    placeholder="Password"
                    style={{ borderRadius: '16px', border: 'none', boxShadow: 'none', color: '#1a1a1a' }}
                  />
                </Form.Item>

                <div className="login-form-footer-container">
                  <Row>
                    <Col span={16}>
                    <div className="login-form-footer">
                    <div className="remember-checkbox-container">
                      <Form.Item name="remember" valuePropName="checked" className="remember-checkbox" >
                        <Checkbox checked={rememberMe} onChange={handleRememberMeChange}>
                          Remember me
                        </Checkbox>
                      </Form.Item>
                    </div>
                    <div className="link-container">
                      {/* <Link to="/register" className="link">Register</Link> */}
                      {/* <Link to="/delete-account" className="link">Delete Account</Link> */}
                    </div>
                    </div>
                    </Col>
                  </Row>
                </div>

                <Form.Item>
                  <Button type="primary" htmlType="submit" className="login-form-button">
                    Log in
                  </Button>
                </Form.Item>

              </Form>


            </div>
          </div>
        </div>
      </Content>
      {/* <Footer className="login-footer">
        <Text>Copyright © 2022-2024 CSSI</Text>
      </Footer> */}
    </Layout>
  );
};

export default Login;
